<template>
  <div class="content">
    <form>
      <transfer-form :datas="dataall"></transfer-form>
      <firma></firma>
      <sklad :datas="dataall"></sklad>
      <paytype :datas="dataall"></paytype>
    </form>
    <b-modal id="modal-close" centered>
      <h4>
        {{$t('Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?')}}
      </h4>

      <template #modal-footer="{ ok, cancel, hide }">
        <button type="button" class="btn btn-success" style="margin-bottom: 16px;"
          @click="$root.$refs.transfer.Savedokument()">{{$t('Да')}}</button>
        <button type="button" class="btn btn-danger" @click='Home()'>{{$t('Нет')}}</button>
        <button type="button" class="btn btn-primary" @click="cancel()">{{$t('Отмена')}}</button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { TransferForm, Firma, Sklad, Paytype } from "@/pages";
export default {
  components: {
    TransferForm,
    Firma,
    Sklad,
    Paytype
  },
  watch: {
    dataall: {
      deep: true,
      handler(val, oldVal) {
        this.$store.state.saved += 1;
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.saved < 2) {
      this.$store.state.saved = null;
      next();
    } else {
      this.$bvModal.show("modal-close");
    }
  },
   created: function() {
    let self=this;
    axios
        .get("api/v1/transfer/last-number")
        .then(function(response) {
            self.dataall.number=response.data.number;
        });
    axios
        .get("api/v1/dollar-exchange-rate/last")
        .then(function(response) {
            self.dataall.dollar_rate=response.data.rate;
            self.$store.state.saved=null;
        });
  },
  data() {
    return {
      dataall: {
        sklad_id: parseInt(localStorage.getItem("sklad_id")),
        created_at: new Date()
          .valueOf()
          .toString()
          .slice(0, 10),
        updated_at: new Date()
          .valueOf()
          .toString()
          .slice(0, 10),
        transfer_sklad_id: 0,
        count_all: 0,
        user_id: parseInt(localStorage.getItem("user_id")),
        summa: 0,
        comment: "",
        confirm:false,
        pay_type_id: 1,
        dollar_rate: 1,
        transfer_table: [
          {
            product_id: 0,
            count: 0,
            current_balance: 0,
            debit_price: 0,
            debit_summa: 0,
            chakana_percent: 0,
            optom_percent: 0,
            chakana_price: 0,
            optom_price: 0,
            chakana_summa: 0,
            optom_summa: 0,
            optom_dollar_price: 0,
            chakana_dollar_price: 0,
            shtrix_kod: ""
          }
        ]
      }
    };
  },
  methods:{
    Home() {
        this.$store.state.saved = null;
        this.$bvModal.hide('modal-close');
        this.$router.push({ name: "Перемешения" });
      }
  }
};
</script>
